import { set } from 'date-fns';
import React, { createContext, useState} from 'react'


export interface Freight {
    id?: number;
    type: string;
    detail: string;
    readyToShip: string;
    deadLine: string;
    status: string;
    observation?: string;
    orderNumber?: string;
    companyId?: number;
    addressId?: number;
    routeId?: number;
    createdBy:{name:string},
    createdAt:string;
    Company?: {
      id: number;
      companyName: string;
    };
    Address: {
      id?: number;
      street: string;
      number: string;
      complement: string;
      cep: number;
      Neighborhood: {
        id: number;
        name: string;
        City: {
          id: number;
          name: string;
          State: {
            id: number;
            name: string;
            uf: string;
          };
        };
      };
    };
    Route?: {
      id: number;
      date: string;
      status: string;
      track: string;
      origin: string | null;
      url: string;
      vehicleId: number;
    };
    Load: {
      id?: number;
      height: string;
      width: string;
      length: string;
      cubage: string;
      weight: string;
      freightId?: number;
      detail: string;
    };
  }

interface FreightContextProps {
    freight: Freight | null;
    setFreight: React.Dispatch<React.SetStateAction<Freight | null>>
}

export const FreightContext = createContext<FreightContextProps>({
    freight: {
      type: "",
      detail: "",
      deadLine: "",
      readyToShip:"",
      status: "",
      createdBy: { name: '' },
      createdAt: '',
      Address: {
        id: 0,
        street: "",
        number: "",
        complement: "",
        cep: 0,
        Neighborhood: {
          name: "",
          id: 0,
          City: {
            name: "",
            id: 0,
            State: {
              id: 0,
              name: "",
              uf: ""
            }
          }
        }
      },
      Load: {
        height: "",
        width: "",
        length: "",
        cubage: "",
        weight: "",
        detail: ""
      }
    },
    setFreight: ()=>{ return}
})


export const FreightProvider: React.FC<any> = ({children})=>{
    const [freight, setFreight] = useState<Freight | null>(null)


    return(
        <FreightContext.Provider value={{freight, setFreight}}>
            {children}
        </FreightContext.Provider>
    )
}



